/**
 * Property-related constants and options.
 */

// =============================================================================
// Select Options
// =============================================================================

export const PROPERTY_TYPE_OPTIONS = [
  { value: 'sfh', label: 'Single family house' },
  { value: 'townhome', label: 'Townhome' },
  { value: 'condo', label: 'Condo' },
  { value: 'multi_family', label: 'Multi-family' },
]

export const CONDITION_OPTIONS = [
  { value: 'excellent', label: 'Excellent' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' },
  { value: 'poor', label: 'Poor' },
  { value: 'needs_repair', label: 'Needs repair/replacement' },
  { value: 'unknown', label: 'Unknown' },
]

export const CLOSING_TIMELINE_OPTIONS = [
  { value: '14_days', label: '14 days' },
  { value: '30_days', label: '30 days' },
  { value: '30_60_days', label: '30-60 days' },
  { value: 'flexible', label: 'Flexible' },
]

// =============================================================================
// API Field Mappings
// =============================================================================

/**
 * Map API field names (snake_case) to form field names (camelCase/nested).
 * Used for parsing API validation errors.
 */
export const PROPERTY_API_TO_FORM_FIELD_MAP: Record<string, string> = {
  // Address fields
  'address.street_address': 'address.streetAddress',
  'address.unit_number': 'address.unitNumber',
  'address.city': 'address.city',
  'address.state': 'address.state',
  'address.zipcode': 'address.zipcode',
  'address.latitude': 'address.latitude',
  'address.longitude': 'address.longitude',
  // Property fields
  'market_value': 'marketValue',
  'floor_price': 'floorPrice',
  'property_type': 'propertyType',
  'is_on_mls': 'isOnMls',
  'follow_up_boss_link': 'followUpBossLink',
  'year_built': 'yearBuilt',
  'overall_condition': 'overallCondition',
  'overall_condition_notes': 'overallConditionNotes',
  'hvac_install_year': 'hvacInstallYear',
  'roof_replacement_year': 'roofReplacementYear',
  'water_heater_install_year': 'waterHeaterInstallYear',
  'plumbing_condition': 'plumbingCondition',
  'plumbing_condition_notes': 'plumbingConditionNotes',
  'electrical_condition': 'electricalCondition',
  'electrical_condition_notes': 'electricalConditionNotes',
  'foundation_condition': 'foundationCondition',
  'foundation_condition_notes': 'foundationConditionNotes',
  'additional_notes': 'additionalNotes',
  'share_market_value': 'shareMarketValue',
  'share_floor_price': 'shareFloorPrice',
  'open_house_dates': 'openHouseDates',
  'offer_deadline': 'offerDeadline',
  'closing_timeline': 'closingTimeline',
}

/**
 * Human-friendly field labels for error messages.
 */
export const PROPERTY_FIELD_LABELS: Record<string, string> = {
  'address.streetAddress': 'Street Address',
  'address.city': 'City',
  'address.state': 'State',
  'address.zipcode': 'ZIP Code',
  'market': 'Market',
  'marketValue': 'Recommended List Price',
  'floorPrice': 'Floor Price',
  'propertyType': 'Property Type',
}

// =============================================================================
// Validation Constants
// =============================================================================

/** Minimum valid year for year_built field */
export const MIN_YEAR_BUILT = 1800

/** Current year (for max year_built validation) */
export const CURRENT_YEAR = new Date().getFullYear()
